import ContentstackLivePreview from '@contentstack/live-preview-utils';
import { ContentstackGatsby } from 'gatsby-source-contentstack/live-preview';

let getCSData = ContentstackGatsby;

if (typeof window !== 'undefined') {
	getCSData = new ContentstackGatsby({
		api_key: process.env.GATSBY_CONTENTSTACK_API_KEY,
		environment: process.env.GATSBY_CONTENTSTACK_ENVIRONMENT,
		delivery_token: process.env.GATSBY_CONTENTSTACK_DELIVERY_TOKEN,
		live_preview: {
			preview_token: process.env.GATSBY_CONTENTSTACK_PREVIEW_TOKEN,
			enable: true,
			preview_host: 'rest-preview.contentstack.com',
		},
	});

	ContentstackLivePreview.init({
		enable: window.top !== window.self,
		debug: true,
		stackSdk: getCSData.stackSdk,
		stackDetails: {
			apiKey: process.env.GATSBY_CONTENTSTACK_API_KEY,
			environment: process.env.GATSBY_CONTENTSTACK_ENVIRONMENT,
		},
		editButton: {
			enable: true,
		},
		mode: 'builder',
	});
}

export { getCSData };
